import { Box, Colors, FlexBox, H5, Tag } from '@helloself/hello-self-ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { BaseTileProps } from '../../../model/types';
import { EmptyTilePlaceholder } from '../../EmptyTilePlaceholder';
import { TagContent } from '../../TagContent';
import Tile from '../../Tile';

export type TopSpecialitiesTileProps = BaseTileProps & {
    topSpecialisms?: string[];
};

export function TopSpecialitiesTile({ topSpecialisms, isLoading, isOwnProfile }: TopSpecialitiesTileProps) {
    if (isLoading) {
        return (
            <Tile>
                <FlexBox flexDirection="column" gap="24px" data-testid="TopSpecialitiesTile">
                    <H5 margin="0">Primary specialisms</H5>
                    <FlexBox gap="8px" flexWrap="wrap">
                        <Skeleton width="140px" height="38px" borderRadius="8px" />
                        <Skeleton width="120px" height="38px" borderRadius="8px" />
                        <Skeleton width="100px" height="38px" borderRadius="8px" />
                    </FlexBox>
                </FlexBox>
            </Tile>
        );
    }

    if (!topSpecialisms || topSpecialisms.length === 0) {
        return (
            <Tile>
                <FlexBox flexDirection="column" gap="12px" data-testid="TopSpecialitiesTile">
                    <H5 margin="0">Primary specialisms</H5>
                    <EmptyTilePlaceholder isOwnProfile={isOwnProfile} />
                </FlexBox>
            </Tile>
        );
    }

    const tagColour = Colors.ExpertBlue400;

    return (
        <Tile>
            <FlexBox flexDirection="column" gap="24px" data-testid="TopSpecialitiesTile">
                <H5 margin="0">Primary specialisms</H5>
                <FlexBox gap="8px" flexWrap="wrap">
                    {topSpecialisms.map((tag, index) => (
                        <Box
                            padding="3px 0"
                            key={index}
                            borderRadius={8}
                            backgroundColor={tagColour}
                            border={`1px solid #e8e8e8`}
                        >
                            <Tag color={Colors.black} backgroundColor={tagColour}>
                                <TagContent>{tag}</TagContent>
                            </Tag>
                        </Box>
                    ))}
                </FlexBox>
            </FlexBox>
        </Tile>
    );
}
